import * as styles from './AuthTitle.module.css'

function AuthTitle({ className = styles.AuthTitle, title }) {
  return <h1 className={className}>{title}</h1>
}

export default AuthTitle
